/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AgentBillingV2ResponseDto } from '../models/AgentBillingV2ResponseDto';
import type { AgentsBillingV2ResponseDto } from '../models/AgentsBillingV2ResponseDto';
import type { PageConversationBillingV2ResponseDto } from '../models/PageConversationBillingV2ResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DefaultService {
    /**
     * Get all agents billing
     * @param xAiAgentOrganizationContext
     * @param startTime
     * @param endTime
     * @returns AgentsBillingV2ResponseDto Success response
     * @throws ApiError
     */
    public static getAgents(
        xAiAgentOrganizationContext: string,
        startTime?: string,
        endTime?: string,
    ): CancelablePromise<AgentsBillingV2ResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/conversations/billing/v2/agents',
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
            query: {
                'start_time': startTime,
                'end_time': endTime,
            },
        });
    }
    /**
     * Get single agent billing
     * @param xAiAgentOrganizationContext
     * @param id
     * @param startTime
     * @param endTime
     * @returns AgentBillingV2ResponseDto Success response
     * @throws ApiError
     */
    public static getAgent(
        xAiAgentOrganizationContext: string,
        id: string,
        startTime?: string,
        endTime?: string,
    ): CancelablePromise<AgentBillingV2ResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/conversations/billing/v2/agents/{id}',
            path: {
                'id': id,
            },
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
            query: {
                'start_time': startTime,
                'end_time': endTime,
            },
            errors: {
                404: `Agent not found`,
            },
        });
    }
    /**
     * Get conversation billing
     * @param xAiAgentOrganizationContext
     * @param agentId
     * @param conversationId
     * @param startTime
     * @param endTime
     * @param page
     * @param size
     * @param sort
     * @returns PageConversationBillingV2ResponseDto Success response
     * @throws ApiError
     */
    public static getConversationBilling(
        xAiAgentOrganizationContext: string,
        agentId?: string,
        conversationId?: string,
        startTime?: string,
        endTime?: string,
        page?: number,
        size: number = 1000,
        sort?: string,
    ): CancelablePromise<PageConversationBillingV2ResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/conversations/billing/v2/conversations',
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
            query: {
                'agent_id': agentId,
                'conversation_id': conversationId,
                'start_time': startTime,
                'end_time': endTime,
                'page': page,
                'size': size,
                'sort': sort,
            },
        });
    }
    /**
     * Get last refresh date
     * @param xAiAgentOrganizationContext
     * @returns string Data is always up-to-date
     * @throws ApiError
     */
    public static getLastRefreshedDate(
        xAiAgentOrganizationContext: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/conversations/billing/v2/last-refresh-date',
            headers: {
                'x-ai-agent-organization-context': xAiAgentOrganizationContext,
            },
        });
    }
}
